import React, { useCallback, useEffect, useState } from 'react';
import nl2br from '../../../value-converter/nl2br';
import { useSelector } from 'react-redux';
import { selectUserContentLocale } from '../../../store/store-slices/userSettingsSlice';

const Translateable = ({ params, field, locale }) => {
    const userContentLocale = useSelector(selectUserContentLocale);

    const [value, setValue] = useState(params?.value);
    const [currentValue, setCurrentValue] = useState([]);
    const [clipped, setClipped] = useState(true);

    useEffect(() => {
        const initialValue = params?.value;
        setValue(initialValue);
        setValueForLocale(userContentLocale || "de", field?.history);
    }, [userContentLocale]);


    const setValueForLocale = useCallback(
        (locale, history) => {
            const multiple = field?.options?.multiple;
            const originalValue = multiple ? value : value ? [value] : [];
            let newValue = [];

            for (const val of originalValue ?? []) {
                if (history) {
                    for (const localeValue in val) {
                        if (val.hasOwnProperty(localeValue)) {
                            newValue.push(localeValue + ': ' + val[localeValue]);
                        }
                    }
                } else {
                    if (val[locale] != null) {
                        newValue.push(val[locale]);
                    }
                }
            }
            setCurrentValue(newValue);
        },
        [field, userContentLocale]
    );

    const handleSetClipped = useCallback((isClipped) => {
        setClipped(isClipped);
    }, []);

    const clipClass = (content) => {
        return clipped ? 'clipped' : '';
    };

    return (
        <>
            {currentValue.map((value, index) => (
                <React.Fragment key={index}>
                    {field?.options?.multiline ? (
                        <span
                            className={`multiline-content ${clipClass(value)}`}
                            dangerouslySetInnerHTML={{ __html: nl2br(value) }}
                            onClick={handleSetClipped}
                        />
                    ) : (
                        <span
                            className={`multiline-content ${clipClass(value)}`}
                            dangerouslySetInnerHTML={{ __html: value }}
                            onClick={handleSetClipped}
                        />
                    )}
                    {index !== currentValue.length - 1 && <br />}
                </React.Fragment>
            ))}
        </>
    );
};

export default Translateable;
